import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookieConsent from "@/components/landing/CookieConsent";
import { PRIVACY_POLICY_PATH } from "@/lib/constants";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path={PRIVACY_POLICY_PATH} element={<PrivacyPolicy />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}
